import { GraphqQlApi as api } from '../api/api.js'
import CryptoJS from 'crypto-js'

function secureRandom() {
  if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
    const a = new Uint32Array(1)
    window.crypto.getRandomValues(a)
    return a[0] / 2 ** 32
  }
  return 0.5
}

export default {
  state: {
    processing: false,
    error: [],
    notify: [],
    downloadedLocales: [],
    globalSearch: '',
    showModal: false,
    overlayText: '',
    dataSources: {},
    needRefreshApp: false,
    appVersion: null,
    isApplicationNotFound: false,
    config: null,
    analitycsSessionId: secureRandom() + ''
  },
  mutations: {
    SET_PROCESSING: (state, payload) => {
      state.processing = payload
    },
    SET_ERROR: (state, payload) => {
      state.error = [...(state.error || []), payload]
    },
    DELETE_ERROR: (state, error) => {
      const index = state.error.findIndex((e) => e?.text === error || e === error)
  
      state.error.splice(index, 1)
    },
    DELETE_NOTIFY: (state, notify) => {
      const index = state[notify.type].findIndex((e) => e?.text === notify.text)
  
      state[notify.type].splice(index, 1)
    },
    CLEAR_ERROR: (state) => {
      state.error = null
    },
    SET_NOTIFY (state, notify) {
      state.notify = [...(state.notify || []), notify]
    },
    SET_LOCALIZATION(state, value) {
      state.downloadedLocales.push(value)
    }, 
    SET_GLOBAL_SEARCH(state, value) {
      state.globalSearch = value
    },
    SET_SHOW_MODAL(state, value) {
      state.showModal = value
    },
    SET_OVERLAY_TEXT(state, value) {
      state.overlayText = value
    },
    SET_OVERLAY_LOADER(state, value) {
      state.overlayLoader = value
    },
    ADD_DATASOURCE_TO_POOL(state, {value, id}) {
      state.dataSources[id] = value
    },
    SET_NEED_REFRESH_APP(state, { needRefreshApp }) {
      state.needRefreshApp = needRefreshApp
    },
    SET_APP_VERSION(state, { version }) {
      state.appVersion = version
    },
    SET_APPLICATION_NOT_FOUND_STATUS(state, value) {
      state.isApplicationNotFound = value
    }
  },
  getters: {
    getProcessing(state) {
      return state.processing
    },
    getError(state) {
      return state.error
    },
    async getConfig(state) {
      if (state.config) {
        return state.config
      }
      const request = new Request(`${window.location.origin}${process.env.VUE_APP_BASE_PATH}config.json`)
      const response = await fetch(request)
      const configJSON = await response.json()
      state.config = window.DOCKERMODE ? configJSON.docker : configJSON.iis
      const responseApp = await fetch(`${window.location.origin}${process.env.VUE_APP_BASE_PATH}assets/app`)
      const buffer = await responseApp.arrayBuffer()
      const key = CryptoJS.enc.Utf8.parse(reader(buffer))
      function reader(arrayBuffer) {
        const view = new DataView(arrayBuffer)
        // magic header "SECR"

        const magic =
          String.fromCharCode(view.getUint8(0)) +
          String.fromCharCode(view.getUint8(1)) +
          String.fromCharCode(view.getUint8(2)) +
          String.fromCharCode(view.getUint8(3))

        if (magic !== 'SECR') {
          throw new Error('Invalid magic header')
        }

        // payload
        const payloadBytes = new Uint8Array(arrayBuffer.slice(5))
        const base64 = new TextDecoder().decode(payloadBytes)
        return atob(base64)
      }
      function decodeValues(propName, object) {
        if (typeof object[propName] === 'object') {
          for (const property in object[propName]) {
            decodeValues(property, object[propName])
          }
        } else if (typeof object[propName] === 'string' && object[propName].startsWith('base64')) {
          let decryptedBytes = CryptoJS.AES.decrypt(object[propName].replace('base64', ''), key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
          object[propName] = decryptedBytes.toString(CryptoJS.enc.Utf8)
        }
      }
      for (const property in state.config) {
        decodeValues(property, state.config)
      }

      return state.config
    },
    getProfileIdp(state) {
      if (state.config?.oidc?.authority) {
        const oidcJwtToken = JSON.parse(sessionStorage.getItem(`oidc.user:${state.config.oidc.authority}:${state.config.oidc.client}`))
        return oidcJwtToken?.profile.idp
      }
    }
  },
  actions: {
    async changeLocaleAsync({ dispatch, commit, state  }, value) {
      if (state.downloadedLocales.find(x => x === value)) {
        return { status: false }
      }

      const { systemLocalization, userLocalization } = await dispatch('getLocalizationAsync')
      commit('SET_LOCALIZATION', value)
      
      return  {
        status: true, 
        systemLocalization,
        userLocalization
      }
    },

    async getLocalizationAsync(context) {
      context.commit('SET_PROCESSING', true)
      const getLocalization = async function (id) {
        // localization for system model with all modules, and user model
        let response = null
        try {
          response = await api.getComplexLocalizationAsync({ id, moduleIds: context.rootState.appRunner.moduleIds })
        } catch (err) {
          // try get system and user localization
          try {
            response = await api.getFullLocalizationAsync({ id })
          } catch (er) {
            console.warn('Getting localization from api - failed. GraphQL is old. Switch to use old way.')
            response = await api.getLocalizationAsync({ id })
          }
        }

        return response
      }

      const response = await getLocalization(context.rootState.appRunner.model.$ID)
      context.commit('SET_PROCESSING', false)
      const parseLocalization = function (stringLocalization) {
        if (!stringLocalization) {
          return {}
        }

        let localization = null
        try {
          localization = JSON.parse(stringLocalization)
        } catch (err) {
          localization = {}
        }

        return localization
      }
      
      return {
        systemLocalization: parseLocalization(response?.data?.webAppModelerQuery?.getLocalization?.localization),
        userLocalization: parseLocalization(response?.data?.webAppModelerQuery?.getLocalization?.userLocalization)
      }
    }
  }
}
